import React, { useRef, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import axiosInstance from "../../api/axios";
import EmploymentCertificate from "../../components/employmentCertificate";

export default function Employment() {
  const componentRef = useRef(null); // 초기값 null
  const [isAccessible, setIsAccessible] = useState(null); // 초기값: null로 설정하여 로딩 중 상태 나타냄
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "재직증명서",
  });

  useEffect(() => {
    const checkAccessValidity = async () => {
      try {
        const response = await axiosInstance.get("/api/user/detail");
        const userData = response.data.data;

        // 현재 시간과 유효기간 비교
        const currentTime = new Date();
        const expiryTime = new Date(userData.certificateAccessExpiry);

        if (expiryTime && currentTime <= expiryTime) {
          setIsAccessible(true); // 유효기간 내라면 접근 허용
        } else {
          setErrorMessage(
            "재직증명서 열람 유효기간이 만료되었습니다. 열람 권한 요청을 다시 해주세요."
          );
          setIsAccessible(false);
        }
      } catch (error) {
        console.error("Error checking access validity:", error);
        setErrorMessage(
          "재직증명서 열람 권한을 확인하는 중 오류가 발생했습니다."
        );
        setIsAccessible(false);
      }
    };

    checkAccessValidity();
  }, []);

  useEffect(() => {
    // 유효하지 않은 경우 경고 메시지와 리다이렉션 처리
    if (isAccessible === false) {
      alert(errorMessage);
      navigate("/my-page");
    }
  }, [isAccessible, errorMessage, navigate]);

  // 로딩 중일 때
  if (isAccessible === null) {
    return <p className="text-center">로딩 중...</p>;
  }

  return (
    <Container className="my-5">
      {/* 재직증명서 컴포넌트 */}
      <div ref={componentRef}>
        <EmploymentCertificate />
      </div>

      {/* PDF 저장 버튼 */}
      <div className="text-center mt-4">
        <button
          style={{
            backgroundColor: "#1769b3",
            border: "none",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          onClick={printFn}
        >
          PDF로 저장
        </button>
      </div>
    </Container>
  );
}
